import { render, staticRenderFns } from "./OrdersFiltering.vue?vue&type=template&id=524c58e8&"
import script from "./OrdersFiltering.vue?vue&type=script&lang=js&"
export * from "./OrdersFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports